module.exports = __webpack_public_path__ + "static/fipcpinkfloral2-caf7f90a75bcdd62c71185f7a8ffcf4e.jpeg";